import { render, staticRenderFns } from "./ArenaCardThumb.vue?vue&type=template&id=71351652&"
import script from "./ArenaCardThumb.vue?vue&type=script&lang=js&"
export * from "./ArenaCardThumb.vue?vue&type=script&lang=js&"
import style0 from "./ArenaCardThumb.vue?vue&type=style&index=0&id=71351652&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports